/**
 * Expose all configurations under the ~/ts/config namespace
 */

export * from "./getStandardPageCount";
export * from "./getTextContent";
